import { render, staticRenderFns } from "./IbToggleButton.vue?vue&type=template&id=4c366e3c&scoped=true"
import script from "./IbToggleButton.vue?vue&type=script&lang=js"
export * from "./IbToggleButton.vue?vue&type=script&lang=js"
import style0 from "./IbToggleButton.vue?vue&type=style&index=0&id=4c366e3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c366e3c",
  null
  
)

export default component.exports